module.exports = __webpack_public_path__ + "img/cpjs14.685ed6b3.jpg";